import React, { useEffect, useState } from 'react';
import '../../styles/DisclaimerPopup.css';
import warningIcon from '../../images/danger.png'; // ⚠️ replace with your icon

const DisclaimerPopup = () => {
  const [showPopup, setShowPopup] = useState(true);

  const handleClose = () => setShowPopup(false);

  useEffect(() => {
    const lockScroll = () => {
      document.body.classList.add('lock-scroll');
      document.documentElement.classList.add('lock-scroll');
    };

    const unlockScroll = () => {
      document.body.classList.remove('lock-scroll');
      document.documentElement.classList.remove('lock-scroll');
    };

    if (showPopup) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => unlockScroll();
  }, [showPopup]);

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <span className="close-button" onClick={handleClose}>&times;</span>
        <img src={warningIcon} alt="Disclaimer" className="popup-icon" />
        <h2>Disclaimer</h2>
        <p>
          This is a <strong>test website</strong> created for educational/demo purposes only.
          It is <strong>not the official website</strong> of Shri Mulikadevi Mahavidyalaya, Nighoj.
        </p>
        <p>
          All rights and content are credited to Shri Mulikadevi Mahavidyalaya, Nighoj.
          For official information, please visit the official site:
        </p>
        <a
          href="https://shrimulikadevicollege.com"
          target="_blank"
          rel="noopener noreferrer"
          className="official-link"
        >
          www.shrimulikadevicollege.com
        </a>
      </div>
    </div>
  );
};

export default DisclaimerPopup;
